// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export enum EventName {
  Blur = 'blur',
  Click = 'click',
  DragStart = 'dragstart',
  Keydown = 'keydown',
  ContextMenu = 'contextmenu',
  Resize = 'resize',
  SelectionChange = 'selectionchange',
  VisibilityChange = 'visibilitychange',
}
